import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../i18n/config';
import { useAppSelector } from '../../redux/store';
import { selectCanEditCurrentCase } from '../../redux/selectors/knowledgebaseSelectors';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';

interface DocumentsEmptyStateProps {
    onUploadClick: () => void;
}

const DocumentsEmptyState: React.FC<DocumentsEmptyStateProps> = ({
    onUploadClick
}) => {
    const { t, i18n } = useTranslation();
    const isRTL = getLanguageDirection(i18n.language) === 'rtl';

    // Check if user can edit
    const canEdit = useAppSelector(selectCanEditCurrentCase);

    return (
        <div
            dir={getLanguageDirection(i18n.language)}
            className="flex items-center justify-center h-full w-full p-6 animate-in fade-in duration-500"
        >
            <Card className="w-full max-w-lg border-dashed shadow-sm bg-card/50">
                <CardHeader className="text-center pb-2">
                    <div className="mx-auto bg-gold/10 p-3 rounded-full w-fit mb-4">
                        <Upload className="h-6 w-6 text-gold" />
                    </div>
                    <CardTitle className="text-xl font-semibold">
                        {t('knowledgebase.noDocuments')}
                    </CardTitle>
                    <CardDescription className="text-muted-foreground mt-2">
                        {t('knowledgebase.addDocumentsPrompt')}
                    </CardDescription>
                </CardHeader>
                <CardContent className="flex justify-center pb-8 pt-4">
                    <Button
                        onClick={onUploadClick}
                        disabled={!canEdit}
                        size="lg"
                        className="gap-2 font-medium"
                    >
                        <Upload className="h-4 w-4" />
                        {t('knowledgebase.uploadDocuments')}
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default DocumentsEmptyState; 
